// extracted by mini-css-extract-plugin
export var btn = "C_mB q_rQ q_rr d_bz d_bP d_bD d_dw";
export var full = "C_vk d_w d_H";
export var hoverStyle = "C_mF";
export var zoom = "C_mG";